module.exports = __webpack_public_path__ + "static/media/andrewohnstad.6f0ddcd2.jpg";